import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from "prop-types";
import ChartSeriesConfigField from './../../components/fields/ChartSeriesConfigField';
import interfaceActions from '../../../interfaces/actions';
import entityActions from '../../../entities/actions';
import _ from './../../../shared/utils/ObjectUtils';
import actions from '../../widgetsSagas/chart/actions';

class ChartSeriesConfigFieldContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            entitiesData: [],

            mergeYAxis: false,
            forceZero: false,
            series: [getNewSeries()]
        }
    }

    componentDidMount() {
        const {
            fetchInterfaceCategoryList,
            fetchEntitiesList,
            fetchInterfaceUnitTypeList,
            value
        } = this.props;

        fetchInterfaceCategoryList();
        fetchEntitiesList();
        fetchInterfaceUnitTypeList();

        //If initial "value" exists, set state to that value
        if (!_.isNilOrEmpty(value)) {
            const {
                mergeYAxis,
                forceZero,
                series
            } = JSON.parse(value);

            this.setState(
                {
                    mergeYAxis,
                    forceZero,
                    series
                },
                () => this.gatherTerminalsAndInterfacesFromSeries(series)
            );
        }
    }

    gatherTerminalsAndInterfacesFromSeries = series => {
        const {
            fetchTerminalsOfEntity,
            fetchInterfacesOfTerminal,
            fetchInterfacesOfEntity
        } = this.props;

        //for each of the interface lines, we need to fetch every terminal and interface list needed
        series.forEach(
            series => {
                series.lines.forEach(
                    line => {
                        line.interfaces.forEach(
                            interfaceLineEntry => {
                                const {
                                    entityId,
                                    terminalId
                                } = interfaceLineEntry;

                                fetchTerminalsOfEntity(entityId);

                                if (!_.isNilOrEmpty(terminalId)) {
                                    //if a terminal Id exists, fetch interfaces from terminal
                                    fetchInterfacesOfTerminal(terminalId)
                                } else {
                                    //else, fetch the entity's interfaces
                                    fetchInterfacesOfEntity(entityId);
                                }
                            }
                        )
                    }
                )
            }
        )
    };

    updateWidgetFormState = () => {
        const {
            handleFieldChange,
            name
        } = this.props;
        let {
            mergeYAxis,
            forceZero,
            series
        } = this.state;

        series = series.map((s, idx) => {
            return {
                ...s,
                seriesId: idx,
                lines : s.lines.map( (l, _idx) => {
                    return {
                        ...l,
                        lineId: _idx
                    }
                })
            }
        });
        handleFieldChange(
            name,
            JSON.stringify({
                mergeYAxis,
                forceZero,
                series
            })
        );
    };

    handleMergeYAxisChange = value => {
        this.setState(
            { mergeYAxis: value },
            this.updateWidgetFormState
        );
    };

    handleForceZeroChange = value => {
        this.setState(
            { forceZero: value },
            this.updateWidgetFormState
        );
    };

    handleAddSeriesButtonClicked = () => {
        let series = [...this.state.series];
        series.push(getNewSeries());
        this.setState(
            { series },
            this.updateWidgetFormState
        );
    };

    handleDeleteSeriesButtonClicked = (seriesIndex) => {
        let series = [...this.state.series];
        series.splice(seriesIndex, 1);
        this.setState(
            { series },
            this.updateWidgetFormState
        );
    };

    handleDuplicateSeriesButtonClicked = (seriesIndex) => {
        let series = [...this.state.series];
        series.push({
            ...series[seriesIndex]
        });
        this.setState(
            { series },
            this.updateWidgetFormState
        );
    };

    //To change "type" and "windowRange"
    handleSeriesFieldChange = (
        seriesIndex,
        fieldKey,
        value
    ) => {
        let series = [...this.state.series];
        series[seriesIndex][fieldKey] = value;
        this.setState(
            { series },
            this.updateWidgetFormState
        );
    };

    handleAddLineToSeriesButtonClicked = seriesIndex => {
        let series = [...this.state.series];
        series[seriesIndex].lines.push(getNewSeriesLine());
        this.setState(
            { series },
            this.updateWidgetFormState
        );
    };

    handleDeleteLineOfSeriesClicked = (seriesIndex, lineIndex) => {
        let series = [...this.state.series];
        series[seriesIndex].lines.splice(lineIndex, 1);
        this.setState(
            { series },
            this.updateWidgetFormState
        );
    };

    handleDuplicateLineOfSeriesClicked = (seriesIndex, lineIndex) => {
        let series = [...this.state.series];
        series[seriesIndex].lines.push({
            ...series[seriesIndex].lines[lineIndex],
            legend: series[seriesIndex].lines[lineIndex].legend + " [Copy]"
        });
        this.setState(
            { series },
            this.updateWidgetFormState
        );
    };

    //To change "legend", "resolution", "interfaceCategory" and "resolution agg"
    handleLineFieldChange = (
        seriesIndex,
        lineIndex,
        fieldKey,
        value
    ) => {

        let series = [...this.state.series];

        if (fieldKey === 'interfaceCategory' &&
            series[seriesIndex].lines[lineIndex][fieldKey] !== value) {
            //If interfaceCategory changes, reset interfaceLines
            series[seriesIndex]
                .lines[lineIndex]
                .interfaces = [getNewLineInterface()];
        }

        series[seriesIndex]
            .lines[lineIndex][fieldKey] = value;

        if(fieldKey === 'unit') {
            let unitSymbol = null;
            if (!_.isNilOrEmpty(value)) {
                //save unitType symbol to simplify the chart rendering process
                const unitTypeObj = this.props.unitTypeList.find( u => {
                    return u.value === value;
                });
                if(!_.isNilOrEmpty(unitTypeObj.properties) && !_.isNilOrEmpty(unitTypeObj.properties.symbol)) {
                    unitSymbol = unitTypeObj.properties.symbol;
                }
            }

            series[seriesIndex]
                .lines[lineIndex].unitSymbol = unitSymbol;
        }

        this.setState(
            { series },
            this.updateWidgetFormState
        );
    };

    handleAddInterfaceToSeriesLineClicked = (seriesIndex, lineIndex) => {
        let series = [...this.state.series];
        series[seriesIndex]
            .lines[lineIndex]
            .interfaces.push(getNewLineInterface());
        this.setState(
            { series },
            this.updateWidgetFormState
        );
    };

    handleDeleteInterfaceOfSeriesLineClicked = (
        seriesIndex,
        lineIndex,
        interfaceIndex
    ) => {
        let series = [...this.state.series];
        series[seriesIndex]
            .lines[lineIndex]
            .interfaces.splice(interfaceIndex, 1);
        this.setState(
            { series },
            this.updateWidgetFormState
        );
    };

    handleEntityChangeInSeries = (
        seriesIndex,
        lineIndex,
        interfaceIndex,
        entityId
    ) => {
        const {
            fetchTerminalsOfEntity,
            fetchInterfacesOfEntity
        } = this.props;

        let series = [...this.state.series];
        series[seriesIndex]
            .lines[lineIndex]
            .interfaces[interfaceIndex]
            .entityId = entityId;
        series[seriesIndex]
            .lines[lineIndex]
            .interfaces[interfaceIndex]
            .terminalId = undefined;
        series[seriesIndex]
            .lines[lineIndex]
            .interfaces[interfaceIndex]
            .interfaceId = undefined;
        this.setState(
            { series },
            () => {
                this.updateWidgetFormState();
                if (!_.isNilOrEmpty(entityId)) {
                    fetchTerminalsOfEntity(entityId);
                    fetchInterfacesOfEntity(entityId);
                }
            }
        );
    };

    handleTerminalChangeInSeries = (
        seriesIndex,
        lineIndex,
        interfaceIndex,
        terminalId
    ) => {
        const {
            fetchInterfacesOfTerminal
        } = this.props;

        let series = [...this.state.series];
        series[seriesIndex]
            .lines[lineIndex]
            .interfaces[interfaceIndex]
            .terminalId = terminalId;
        series[seriesIndex]
            .lines[lineIndex]
            .interfaces[interfaceIndex]
            .interfaceId = undefined;
        this.setState(
            { series },
            () => {
                this.updateWidgetFormState();
                if (!_.isNilOrEmpty(terminalId)) fetchInterfacesOfTerminal(terminalId);
            }
        );
    };

    handleInterfaceChangeInSeries = (
        seriesIndex,
        lineIndex,
        interfaceIndex,
        interfaceId
    ) => {
        let series = JSON.parse(JSON.stringify(this.state.series));
        series[seriesIndex]
            .lines[lineIndex]
            .interfaces[interfaceIndex]
            .interfaceId = interfaceId;
        this.setState(
            { series },
            this.updateWidgetFormState
        );
    };

    render() {
        const {
            interfaceCategoryList,
            entityList,
            unitTypeList,
            terminalsListByEntityId,
            interfacesListByEntityId,
            interfacesListByTerminalId
        } = this.props;

        const {
            mergeYAxis,
            forceZero,
            series
        } = this.state;

        return <ChartSeriesConfigField
            interfaceCategoryList={interfaceCategoryList}
            entityList={entityList}
            unitList={unitTypeList}

            //Entity -> Terminals,
            //Entity -> Interfaces,
            //Terminals -> Interfaces
            terminalsListByEntityId={terminalsListByEntityId}
            interfacesListByEntityId={interfacesListByEntityId}
            interfacesListByTerminalId={interfacesListByTerminalId}

            /*Form Data*/
            mergeYAxis={mergeYAxis}
            forceZero={forceZero}
            series={series}

            /*Handlers*/
            handleMergeYAxisChange={this.handleMergeYAxisChange}
            handleForceZeroChange={this.handleForceZeroChange}

            handleSeriesFieldChange={this.handleSeriesFieldChange}
            handleAddSeriesButtonClicked={this.handleAddSeriesButtonClicked}
            handleDeleteSeriesButtonClicked={this.handleDeleteSeriesButtonClicked}
            handleDuplicateSeriesButtonClicked={this.handleDuplicateSeriesButtonClicked}

            handleAddLineToSeriesButtonClicked={this.handleAddLineToSeriesButtonClicked}
            handleDeleteLineOfSeriesClicked={this.handleDeleteLineOfSeriesClicked}
            handleDuplicateLineOfSeriesClicked={this.handleDuplicateLineOfSeriesClicked}
            handleLineFieldChange={this.handleLineFieldChange}

            handleAddInterfaceToSeriesLineClicked={this.handleAddInterfaceToSeriesLineClicked}
            handleDeleteInterfaceOfSeriesLineClicked={this.handleDeleteInterfaceOfSeriesLineClicked}

            handleEntityChangeInSeries={this.handleEntityChangeInSeries}
            handleTerminalChangeInSeries={this.handleTerminalChangeInSeries}
            handleInterfaceChangeInSeries={this.handleInterfaceChangeInSeries}
        />;
    }
}

const getNewSeries = ({
                          type,
                          windowRange,
                      } = {}) => ({
    type,
    windowRange,
    lines: [getNewSeriesLine()]
});

const getNewSeriesLine = ({
                              legend,
                              resolution,
                              interfaceCategory,
                              resolutionAggregator
                          } = {}) => ({
    legend,
    resolution,
    interfaceCategory,
    resolutionAggregator,
    interfaces: [getNewLineInterface()],
});

const getNewLineInterface = ({
                                 entityId,
                                 terminalId,
                                 interfaceId
                             } = {}) => ({
    entityId,
    terminalId,
    interfaceId
});

const mapStateToProps = ({
                             entitiesReducer,
                             interfacesReducer,
                             dashboardAndWidgetsReducer
                         }) => {
    const { chartConfigsReducer } = dashboardAndWidgetsReducer;
    return {
        terminalsListByEntityId: chartConfigsReducer.terminalsListByEntityId,
        interfacesListByEntityId: chartConfigsReducer.interfacesListByEntityId,
        interfacesListByTerminalId: chartConfigsReducer.interfacesListByTerminalId,

        unitsByInterfaceCategoryId: chartConfigsReducer.unitsByInterfaceCategoryId,

        interfaceCategoryList: interfacesReducer.categoryList,
        unitTypeList: interfacesReducer.unitTypeList,
        entityList: entitiesReducer.entityList
    };
};

const mapDispatchToProps = {
    fetchTerminalsOfEntity: actions.fetchTerminalsOfEntity,
    fetchInterfacesOfEntity: actions.fetchInterfacesOfEntity,
    fetchInterfacesOfTerminal: actions.fetchInterfacesOfTerminal,

    /*
        This will not be used since BE does not support search of units by category
        fetchUnitsOfInterfaceCategory: actions.fetchUnitsOfInterfaceCategory,
    */

    fetchInterfaceCategoryList: interfaceActions.getCategoryList,
    fetchInterfaceUnitTypeList: interfaceActions.getUnitTypeList,
    fetchEntitiesList: entityActions.getEntityList
};

ChartSeriesConfigFieldContainer.propTypes = {
    name: PropTypes.string,
    fieldConfig: PropTypes.object,
    handleFieldChange: PropTypes.func,
    formData: PropTypes.object
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ChartSeriesConfigFieldContainer);
